import React from "react";

/* Padlock — marks a field carried over from the profile and not editable here. */
export const LockIcon = ({ size = 12, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <rect x="4" y="10" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 10V7a4 4 0 118 0v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default LockIcon;
